module.exports = __webpack_public_path__ + "img/qr_rectangle_03.c50920d9.png";